<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="wallet_icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g>
      <path
        id="Path_1380"
        data-name="Path 1380"
        d="M20,15.5H18a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h2a1,1,0,0,1,1,1v2A1,1,0,0,1,20,15.5Z"
        fill="none"
        :stroke="clr ? clr : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1381"
        data-name="Path 1381"
        d="M20,11.5v-3a2,2,0,0,0-2-2H4.5A1.5,1.5,0,0,1,3,5H3A1.5,1.5,0,0,1,4.5,3.5H17"
        fill="none"
        :stroke="clr ? clr : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1382"
        data-name="Path 1382"
        d="M20,15.5v3a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V5"
        fill="none"
        :stroke="clr ? clr : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>
